import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import {
  ConfirmationProvider,
  PaginatedTableProvider,
  ToastProvider,
} from "@intrasys/core-ui";
import AppRoutes from "@/routes/AppRoutes";
import PageOptionModal, {
  PageOptionProvider,
} from "./components/PageOptionModal";
import { AlertProvider } from "@intrasys/core-ui";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      suspense: true,
    },
  },
});
function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <PaginatedTableProvider queryClient={queryClient}>
        <ToastProvider autoClose={5000} position="bottom-right">
          <ConfirmationProvider>
            <PageOptionProvider>
              <AlertProvider>
                <AppRoutes />
              </AlertProvider>
            </PageOptionProvider>
          </ConfirmationProvider>
        </ToastProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </PaginatedTableProvider>
    </QueryClientProvider>
  );
}

export default App;
